module.exports = __webpack_public_path__ + "static/img/banner.d56c910f.png";